import './header.css'
import VideoPlay from '../../assets/0129.mp4'
import {BsFacebook} from 'react-icons/bs'
import {useRef, useEffect} from 'react'
import {AiOutlineInstagram, AiOutlineFacebook, AiOutlineTwitter} from 'react-icons/ai'
import fxImage from '../../assets/bg.png'


const Header = () => {
 
  return (
   <header id="header">
      <div className=" header__container ">
        {/* <img src={fxImage} alt="" /> */}
      <video 
      controls='' 
      muted="muted" 
      autoPlay={true}
       loop='loop' 
       preLoad="auto"
       className='shortVideo'>
           <source src={VideoPlay} type="video/mp4"/>
      </video>
           <div className="video__wrap">
              <div className="content">
                  <p className='desc'>
                    <h1>D<span>Views</span></h1>
                    <h4> 360 Photo & Video Spinner booth </h4>
                    {/* <h4>We help you Capture Some Beautiful & fun memories at your Event.</h4> */}
                </p>
             
              </div>

           </div>
           
      </div>
    
        <div className="header_socials">

        </div>
   </header>
  )
}

export default Header